import { getCookies, getSubdomainFromHost, setCookies } from "@/helpers/utils";
import { clearCache, readCache, writeCache } from "./configStore";
import { stringify } from "querystring";

const ttl = 3 * 28 * 24 * 60 * 60 * 1000; // 3 months

const isServer = typeof window === "undefined";

// This metod will return the config object or else fetch and store in cache or cookie
export async function getConfig({ refreshCookie = false, req = null, res = null } = {}) {
  let cacheConfig = null;
  let cookieConfig = null;
  let clientCode = null;

  /** -------------------------
   * REFRESH COOKIE
   -------------------------- */
  if (refreshCookie && res && req) {
    try {
      const cache = await readCache();
      console.log('Refresh cookie forcefully');
      if (cache?.config) {
        const clientCode = getSubdomainFromHost(req.headers.host);
        res.setHeader("Set-Cookie", `nevendo_client_config=${JSON.stringify(cache.config[clientCode])}; Path=/;`);
      }
    } catch (e) {
      // silently fail
    }
  }

  /** -------------------------
   * SERVER CACHE (SSR ONLY)
   -------------------------- */
  if (isServer) {
    try {
      const cache = await readCache();

      if (cache?.config && Date.now() - cache.lastFetched < ttl ) {
        return cache.config;
      }

      cacheConfig = cache?.config;
    } catch (err) {
      // silently fail — cache must never break runtime
    }
  }

  /** -------------------------
   * CLIENT COOKIES (BROWSER ONLY)
   -------------------------- */
  if (!isServer) {
    try {
      cookieConfig = getCookies("nevendo_client_config");
      clientCode = getCookies("nevendo_client_code");

      if (cookieConfig) {
        if (cookieConfig[clientCode]) {
          return cookieConfig;
        }

      }
    } catch (err) {
      // corrupted cookie? ignore safely
    }
  }

  /** -------------------------
   * FETCH FALLBACK (BOTH) ONLY IF NO COOKIE OR CACHE
   -------------------------- */
  let data;
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_DOMAIN_CONFIG_URL}?clientCode=${encodeURIComponent(clientCode || '')}`,
      { cache: "no-store" }
    );
    if (!res.ok) {
      throw new Error("Invalid client");
    }

    data = await res.json();
  } catch (e) {
    throw new Error("Configuration error. Check configuration end point and try again.");
  }

  /** -------------------------
   * WRITE BACK
   -------------------------- */
  if (isServer) {
    try {

      if (data) {
        await clearCache();
        await writeCache({
          lastFetched: Date.now(),
          config: data,
        });
      }
    } catch (e){
       console.log('data isServer', e);
     }
  }

  if (!isServer) {
    try {
      const cookie = getCookies("nevendo_client_code");
      setCookies(
        "nevendo_client_config",
        cookie ? JSON.stringify({ [cookie]: data[cookie] }) : JSON.stringify(data)
      );
    } catch (e){
      console.log('!isServer',e);
     }
  }

  return data;
}
